<template>
  <div class="activity_details">
    <div class="information">
      <div class="content">
        <table>
          <tr>
            <td class="name">对接洽谈主题：</td>
            <td class="price">{{ details.title }}</td>
          </tr>
          <tr>
            <td class="name">对接洽谈时间：</td>
            <td class="price">{{ details.dockingDateStart }}</td>
          </tr>
          <tr>
            <td class="name">对接方式：</td>
            <td class="price">{{ details.dockingMode }}</td>
          </tr>
          
          <tr>
            <td class="name">企业对接人：</td>
            <td class="price">{{ details.companyDockingUser }}</td>
          </tr>
          <tr>
            <td class="name">主要参与人：</td>
            <td class="price">{{ details.mainParticipants }}</td>
          </tr>
          <tr>
            <td class="name">对接洽谈内容：</td>
            <td class="price">{{ details.danContents }}</td>
          </tr>
          <tr>
            <td class="name">单位：</td>
            <td class="price">{{ details.orgName }}</td>
          </tr>
          <tr>
            <td class="name">创建人：</td>
            <td class="price">{{ details.creatorName }}</td>
          </tr>
          <tr>
            <td class="name">创建时间：</td>
            <td class="price">{{ details.createTime }}</td>
          </tr>
        </table>
        
      </div>
    </div>
    <div class="information" v-if="details.photoPath.length || details.download.length">
      <div class="top">
        <img
          v-for="(item, index) in details.photoPath"
          :key="index"
          :src="item"
          alt=""
        />
      </div>
      <div>
        <div
          v-for="(item, index) in details.download"
          :key="index"
          @click="download(item)"
          class="download"
        >
          <img src="../../../assets/investment/download.png" alt="" />
          <div class="span">
            <span>附件{{ index + 1 }}：{{ item.filename }}</span>
          </div>
        </div>
      </div>
    </div>
    <downIos :downUrl="downUrl" v-if="showDown" @cancelDown="cancelDown"></downIos>
    <!-- <div class="foot" v-if="type == 'Activity'">
      <button @click="cutout()">
        删除
      </button>
    </div> -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Vue from 'vue';
import { Toast } from 'vant';
import common from '../../../utils/common.js';
import downIos from '../components/downIos'

Vue.use(Toast);
export default {
  name: "investorParticularsDetails",
  components: { downIos },
  props: {},
  data() {
    return {
      showDown:false,
      downUrl: '',
      details: {
        activityTheme: "",
        busiManageTypeName: "",
        overDate: "",
        residentBackDate: "",
        merchants: "",
        orgName: "",
        createTime: "",
        creatorName: "",
        photoPath: [],
        download: [],
      },
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
    
  },
  watch: {},

  created() {
    
    this.setInvestmentTitle("对接洽谈详情");
    this.getDockingNegotiate({ id: this.id }).then((res) => {
      if (res.photoPath) {
        if (res.photoPath.indexOf('◎') !== -1) {
            res.photoPath = res.photoPath.split("◎");
          } else if (res.photoPath.indexOf(',') !== -1) {
            res.photoPath = res.photoPath.split(",")
          } else {
            res.photoPath = [res.photoPath]
          }
      } else {
        res.photoPath = [];
      }
      res.download = [];
      if (res.filePath) {
        if (res.filePath.indexOf('◎') !== -1) {
            res.filePath = res.filePath.split("◎");
          } else if (res.filePath.indexOf(',') !== -1) {
            res.filePath = res.filePath.split(",")
          } else {
            res.filePath = [res.filePath]
          }
        res.filePath.forEach((element) => {
          res.download.push({
            link: element,
            filename: element.substring(element.lastIndexOf("&&") + 2),
          });
        });
      } else {
        res.filePath = [];
      }
      res.createTime = res.createTime? res.createTime.replace(/T/g,' ').replace(/Z/g,''):''
      this.details = res;
    });
  },
  methods: {
    ...mapActions("investment", [
      "setInvestmentTitle",
      "getInvestLoadBy",
      "removeInvest",
      "getDockingNegotiate",
    ]),
    cancelDown(type){
                if(type=='success'){
                  this.showDown=false;
                  setTimeout(()=>{this.$Toast('复制成功')},1000)
                }else{
                  this.showDown=false;
                }
            },
    download(item) {
      this.downUrl = item.link
      var u = navigator.userAgent;
      const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      if (isAndroid) {
        window.location.href = item.link;
      } else {
        this.$dispatch("downIosUrl", item.link);
        this.showDown = true
      }
    },
    cutout() {
      this.removeInvest({id: this.id}).then(res =>{
        this.$router.push({ path: '/investment/activity' })
      }).catch(err => {

      })
    }
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.activity_details {
  min-height: 100%;
  font-family: PingFangSC-Regular;
  padding: 12px 12px 108px;
  background: #F5F6F9;

  .information {
    background: #ffffff;
    padding: 0 20px 12px;
    margin-bottom: 12px;
    border-radius: 3px;
    .top {
      padding: 16px 0 0px;
      border-bottom: 0.5px solid rgba(238, 238, 238, 1);
      img {
        height: 143px;
        margin-bottom: 12px;
      }
    }
    .download {
      font-size: 0;
      padding: 12px 0 3px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img {
        display: inline;
        width: 10px;
        height: 12px;
        line-height: 16px;
        margin-right: 6px;
      }
      .span {
        span {
          color: #2283e6;
          font-size: 12px;
          line-height: 16px;
          display: inline-block;
          transform: scale(0.8333);
          transform-origin: left center;
        }
      }
    }
    .content {
      color: #333333;
      font-size: 12px;
      line-height: 17px;
      table {
        table-layout: fixed;
        max-width: 100%;
        word-wrap: break-word;
        text-overflow: ellipsis;
        td {
          padding-top: 12px;
          padding-right: 8px;
          vertical-align: top;
          white-space: normal;
        }
        .name {
          white-space: nowrap;
          margin-right: 8px;
        }
      }
    }
  }
  .foot {
    position: fixed;
    bottom: 0;
    left: 0;
    bottom: 0;
    padding: 13px 12px 47px;
    background: #ffffff;
    width: 100%;
    button {
      border: 0;
      background: #36b374;
      display: block;
      width: 100%;
      padding: 13px;
      line-height: 22px;
      font-size: 16px;
      color: #ffffff;
      border-radius: 3px;
    }
  }
}
</style>